import reducer from './users.reducer';

export default reducer;
